import { FC } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const Bridge: FC<SvgIconProps> = ({ sx, ...props }) => (
  <SvgIcon
    viewBox="0 0 32 32"
    sx={{
      width: '32px',
      height: '32px',
      fill: 'none',
      color: '#B4EB56',
      ...sx,
    }}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.3333 28H6.66667C5.19333 28 4 26.8067 4 25.3333V6.66667C4 5.19333 5.19333 4 6.66667 4H25.3333C26.8067 4 28 5.19333 28 6.66667V25.3333C28 26.8067 26.8067 28 25.3333 28Z"
      stroke="#B4EB56"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.7734 10.8887V10.8887C13.7734 9.66202 14.7681 8.66602 15.9961 8.66602V8.66602C17.2228 8.66602 18.2188 9.66068 18.2188 10.8887V10.8887C18.2188 12.1153 17.2241 13.1113 15.9961 13.1113V13.1113C14.7681 13.11 13.7734 12.1153 13.7734 10.8887Z"
      stroke="#B4EB56"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.39062 19.7774V19.7774C8.39062 18.5507 9.38529 17.5547 10.6133 17.5547V17.5547C11.84 17.5547 12.836 18.5494 12.836 19.7774V19.7774C12.8346 21.004 11.8413 22 10.6133 22V22C9.38529 22 8.39063 21.0054 8.39063 19.7774H8.39062Z"
      stroke="#B4EB56"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.1641 19.7774V19.7774C19.1641 18.5507 20.1587 17.5547 21.3867 17.5547V17.5547C22.6134 17.5547 23.6094 18.5494 23.6094 19.7774V19.7774C23.6094 21.004 22.6147 22 21.3867 22V22C20.1587 22 19.1641 21.0054 19.1641 19.7774Z"
      stroke="#B4EB56"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.1836 15.2676L11.5703 17.7876"
      stroke="#B4EB56"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.2031 12.7598L18.8165 15.2664"
      stroke="#B4EB56"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M19.16 19.7741H16" stroke="#B4EB56" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </SvgIcon>
);

export const BridgeDark: FC<SvgIconProps> = ({ sx, ...props }) => (
  <SvgIcon
    viewBox="0 0 32 32"
    sx={{
      width: '24px',
      height: '24px',
      fill: 'none',
      color: '#B4EB56',
      ...sx,
    }}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.3333 28H6.66667C5.19333 28 4 26.8067 4 25.3333V6.66667C4 5.19333 5.19333 4 6.66667 4H25.3333C26.8067 4 28 5.19333 28 6.66667V25.3333C28 26.8067 26.8067 28 25.3333 28Z"
      stroke="#090C18"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.7734 10.8887V10.8887C13.7734 9.66202 14.7681 8.66602 15.9961 8.66602V8.66602C17.2228 8.66602 18.2188 9.66068 18.2188 10.8887V10.8887C18.2188 12.1153 17.2241 13.1113 15.9961 13.1113V13.1113C14.7681 13.11 13.7734 12.1153 13.7734 10.8887Z"
      stroke="#090C18"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.39062 19.7774V19.7774C8.39062 18.5507 9.38529 17.5547 10.6133 17.5547V17.5547C11.84 17.5547 12.836 18.5494 12.836 19.7774V19.7774C12.8346 21.004 11.8413 22 10.6133 22V22C9.38529 22 8.39063 21.0054 8.39063 19.7774H8.39062Z"
      stroke="#090C18"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.1641 19.7774V19.7774C19.1641 18.5507 20.1587 17.5547 21.3867 17.5547V17.5547C22.6134 17.5547 23.6094 18.5494 23.6094 19.7774V19.7774C23.6094 21.004 22.6147 22 21.3867 22V22C20.1587 22 19.1641 21.0054 19.1641 19.7774Z"
      stroke="#090C18"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.1836 15.2676L11.5703 17.7876"
      stroke="#090C18"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.2031 12.7598L18.8165 15.2664"
      stroke="#090C18"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M19.16 19.7741H16" stroke="#090C18" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </SvgIcon>
);
